import { render, staticRenderFns } from "./edit-password.vue?vue&type=template&id=2a8c8e00&scoped=true"
import script from "./edit-password.vue?vue&type=script&lang=ts"
export * from "./edit-password.vue?vue&type=script&lang=ts"
import style0 from "./edit-password.vue?vue&type=style&index=0&id=2a8c8e00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8c8e00",
  null
  
)

export default component.exports